import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api/types"
import { MappingTable } from "~/pages/Brand/OrganizationSettings/Mapping/components/MappingTable"
import { useFindTypeKeysQuery } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useFindTypeKeysQuery"

type Props = {
  materialTypes: FindMappingByTypeResponseDto[]
}

export const MaterialMapping = ({ materialTypes }: Props) => {
  const {
    data: materialTypesList,
    isLoading,
    isError,
  } = useFindTypeKeysQuery("MATERIAL")
  const { t } = useTranslation()
  if (isLoading) {
    return <Loader />
  }
  if (isError) {
    return (
      <InfoBox
        color="red"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }

  return (
    <>
      <MappingTable
        types={materialTypes}
        typesList={materialTypesList.data.map((type) => ({
          ...type,
          deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
        }))}
        typeName="MATERIAL"
      />
    </>
  )
}
